export const createBlobUrl = (
  blob: Blob
) => {
  return URL.createObjectURL(blob);
};


export const openBlobInNewTab = (
  blob: Blob
) => {
  const blobUrl =
    createBlobUrl(blob);

  window.open(
    blobUrl,
    "_blank",
    "noopener,noreferrer"
  );

  setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
  }, 60_000);
};


export const downloadBlob = (
  blob: Blob,
  fileName: string
) => {
  const blobUrl =
    createBlobUrl(blob);

  const link =
    document.createElement("a");

  link.href = blobUrl;

  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
  }, 1_000);
};